<template>
  <OceanEngineAiData creative-detail />
</template>

<script>
import OceanEngineAiData from './OceanEngineAiData.vue'

export default {
  name: 'Game3',
  components: { OceanEngineAiData }
}
</script>
